import http from 'helpers/http';

const API_URL = process.env.REACT_APP_API_URL;

export async function getMyCustomAvatars() {
    const response = await http.get(`${API_URL}api/usercustomavatars`);
    return response.data;
}

export async function createCustomAvatar(imageBase64, configJson) {
    const response = await http.post(`${API_URL}api/usercustomavatars`, {
        imageBase64,
        configJson: JSON.stringify(configJson)
    });
    return response.data;
}

export async function updateCustomAvatar(id, imageBase64, configJson) {
    const response = await http.put(`${API_URL}api/usercustomavatars/${id}`, {
        imageBase64,
        configJson: JSON.stringify(configJson)
    });
    return response.data;
}

export async function deleteCustomAvatar(id) {
    const response = await http.delete(`${API_URL}api/usercustomavatars/${id}`);
    return response.data;
}
